/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
export const log = (type: string, props: any) => {
  if ((window as any).plausible) {
    (window as any).plausible(type, { props: { ...props } });
  }
};
